import React from "react";
import { Helmet } from "react-helmet";

// UI global
import Header from "../../components/ui/Header";
import BreadcrumbNavigation from "../../components/ui/BreadcrumbNavigation";

// Secciones
import GlobalSphereBackground from "../../components/3d/GlobalSphereBackground";

// Secciones
import ServicesHero from "./components/ServicesHero";
import ServicesShowcase from "./components/ServicesShowcase";
import EngineeringProcessTimeline from "./components/EngineeringProcessTimeline";
import MetricsDisplay from "./components/MetricsDisplay";
import StickyQuoteCTA from "./components/StickyQuoteCTA";
import FooterSection from "pages/homepage-with-3d-construction-experience/components/FooterSection";

const ServicesOverview = () => {
  return (
    <>
      <Helmet>
        <title>Servicios - SIRECC | Construcción e Ingeniería Especializada</title>
        <meta
          name="description"
          content="Servicios especializados de SIRECC: obra civil, acabados, comunicaciones, mobiliario, mantenimiento locativo, hidrosanitarios, sistemas eléctricos, espacios públicos, gas natural y vidrio aluminio."
        />
        <link rel="canonical" href="/services-overview" />
      </Helmet>

      {/* Fondo con esfera global */}
      <div className="min-h-screen relative bg-transparent">
        <GlobalSphereBackground />

        {/* Overlay más suave para dejar ver la esfera */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 z-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(11,22,32,0.92) 0%, rgba(29,41,70,0.85) 35%, rgba(11,22,32,0.98) 100%)",
          }}
        />

        {/* Contenido */}
        <div className="relative z-10">
          <Header />

          <main className="relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-6">
              <BreadcrumbNavigation />
            </div>

            <ServicesHero />

            {/* Showcase: padding inferior alto para no chocar con la CTA fija */}
            <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-8 pb-36">
              <ServicesShowcase />
            </div>

            <EngineeringProcessTimeline />

            <MetricsDisplay />
            {/* Footer corporativo */}
            <FooterSection />
            <StickyQuoteCTA />


          </main>
        </div>
      </div>
    </>
  );
};

export default ServicesOverview;
